import React from 'react';
import css from './SectionOfferingsForm.module.css';
import { FieldTextInput } from '../../../components';
const TitleInputField = ({ label, id, fieldName }) => {
  return (
    <div className={css.fieldGroup}>
      <FieldTextInput
        className={css.field}
        type="text"
        id={id}
        name={fieldName}
        label={label}
        disabled
      />
    </div>
  );
};

export default TitleInputField;
